import { Component, Input, OnInit } from '@angular/core';
import { fadeInOut } from '@shared/src/animations';
import { BookingController } from '@shared/src/controllers/booking/booking.controller';
import { iBooking } from '@shared/src/dtos/booking/iBooking';

@Component({
  selector: 'shared-booking-header',
  templateUrl: './shared.booking.header.component.html',
  styleUrls: ['./shared.booking.header.component.scss'],
  animations: [fadeInOut]
})
export class SharedBookingHeaderComponent implements OnInit {

  public expanded: boolean = true;

  constructor(protected bookingController: BookingController) { }

  ngOnInit(): void { }

  private _booking: iBooking;
  @Input() public set booking(v: iBooking) {
    if (this._booking == v)
      return;

    this._booking = v;
  }
  public get booking(): iBooking {
    return this._booking;
  }

  toggleView() {
    this.expanded = !this.expanded;
  }

  pretty(value: any): string {
    return JSON.stringify(value);
  }
}
